import { getBasePath, isTestnet } from "@/shared/config";

export const LEGACY_APPLICATION_URL = "https://www.artblocks.io/legacy/apply";

export const AB_FLAGSHIP_URL =
  process.env.NEXT_PUBLIC_AB_FLAGSHIP_URL ??
  (isTestnet() ? "https://dev.artblocks.io" : "https://artblocks.io");

export const getBaseUrl = () => {
  if (getBasePath()) return `${AB_FLAGSHIP_URL}${getBasePath()}`;
  return AB_FLAGSHIP_URL;
};

export const getEtherscanTxUrl = (txHash: string) => {
  return isTestnet()
    ? `https://sepolia.etherscan.io/tx/${txHash}`
    : `https://etherscan.io/tx/${txHash}`;
};

export const getEtherscanWalletUrl = (walletAddress: string) => {
  return isTestnet()
    ? `https://sepolia.etherscan.io/address/${walletAddress}`
    : `https://etherscan.io/address/${walletAddress}`;
};

export const getArtistCanonicalPath = ({
  id,
  slug,
}: {
  id: string;
  slug?: string;
}) => {
  return `/artists/${slug || id}`;
};

export const getArtistCanonicalUrl = ({
  id,
  slug,
}: {
  id: string;
  slug?: string;
}) => {
  return `${getBaseUrl()}${getArtistCanonicalPath({ id, slug })}`;
};

export const getCollectionCanonicalUrl = ({
  id,
  slug,
}: {
  id: string;
  slug?: string;
}) => {
  return `${getBaseUrl()}/collections/${slug || id}`;
};

export const getCollectionPath = (idOrSlug: string) => {
  return `/collections/${idOrSlug}`;
};

export const getCollectionUrl = (idOrSlug: string) => {
  return `${getBaseUrl()}${getCollectionPath(idOrSlug)}`;
};

export const getAssetUrl = (contractAddress: string, tokenId: string) => {
  return `${getBaseUrl()}/asset/${contractAddress}/${tokenId}`;
};

export const getArtBlocksProjectUrl = (projectId: string) => {
  return `${AB_FLAGSHIP_URL}/project/${projectId}`;
};

export const getAssetPath = (contractAddress: string, tokenId: string) => {
  return `/asset/${contractAddress}/${tokenId}`;
};

export const getPrivacyPolicyUrl = () => {
  return `https://www.artblocks.io/privacy-policy.pdf`;
};

export const getTermsOfServiceUrl = () => {
  return `https://www.artblocks.io/user-terms.pdf`;
};

export const getWalletPath = (walletAddress: string) => {
  return `/wallets/${walletAddress}`;
};

export const getWalletUrl = (walletAddress: string) => {
  return `${getBaseUrl()}${getWalletPath(walletAddress)}`;
};

export const getUpcomingPath = () => {
  return `/calendar`;
};

export const getStudioApplicationPath = () => {
  return `/studio/apply`;
};

export const getArtistResidencyApplicationPath = () => {
  return `/studio/apply/residency`;
};

export const getActivityPath = () => {
  return `/activity`;
};

export const getRankingsPath = () => {
  return `/rankings`;
};

export const getSellPath = () => {
  return `/sell`;
};

export const getListingsPath = () => {
  return `/listings`;
};

export const getOffersPath = (address: string) => {
  return `/wallets/${address}?tab=offers`;
};

// Flagship
export const getFlagshipArticlePath = (slug: string) => {
  return `/articles/${slug}`;
};

export const getFlagshipArticleUrl = (slug: string) => {
  return `${AB_FLAGSHIP_URL}${getFlagshipArticlePath(slug)}`;
};

export const getFlagshipExhibitionPath = (slug: string) => {
  return `/exhibitions/${slug}`;
};

export const getFlagshipExhibitionUrl = (slug: string) => {
  return `${AB_FLAGSHIP_URL}${getFlagshipExhibitionPath(slug)}`;
};

export const getFlagshipCollectionsPath = (queryString?: string) => {
  return `/discover${queryString ?? ""}`;
};

export const getFlagshipCollectionsUrl = (queryString?: string) => {
  return `${AB_FLAGSHIP_URL}${getFlagshipCollectionsPath(queryString)}`;
};

export const getFlagshipCollectionPath = (slug: string) => {
  return `/collection/${slug}`;
};

export const getFlagshipCollectionUrl = (slug: string) => {
  return `${AB_FLAGSHIP_URL}${getFlagshipCollectionPath(slug)}`;
};

export const getFlagshipTokenPath = (
  contractAddress: string,
  tokenId: string
) => {
  return `/token/${contractAddress}/${tokenId}`;
};

export const getFlagshipTokenUrl = (
  contractAddress: string,
  tokenId: string
) => {
  return `${AB_FLAGSHIP_URL}${getFlagshipTokenPath(contractAddress, tokenId)}`;
};

export const getFlaghshipLoginUrl = () => {
  return `${AB_FLAGSHIP_URL}/login`;
};
